/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseTestGroupDto } from './BaseTestGroupDto';
import type { SpecificationTestGroupDto } from './SpecificationTestGroupDto';
export type BaseTestAreaDto = {
    readonly id?: string;
    readonly createdDate?: string;
    readonly createdBy?: string;
    readonly modifiedDate?: string;
    readonly modifiedBy?: string;
    readonly version?: number;
    name?: string;
    testAreaType: BaseTestAreaDto.testAreaType;
    operatingFluidTypeId: string;
    readonly testGroups?: Array<(BaseTestGroupDto | SpecificationTestGroupDto)>;
};
export namespace BaseTestAreaDto {
    export enum testAreaType {
        SPECIFICATION = 'SPECIFICATION',
        GENERIC = 'GENERIC',
    }
}

